export default {
  list: {
    title: '供应商合同管理',
    subtitle: '统一查看从韶音一诺合同系统同步的供应商合同',
    filterTitle: '合同筛选',
    resultTitle: '合同列表',
    resultCount: '共 {count} 条',
    exportTitle: '供应商合同'
  },
  detail: {
    title: '供应商合同详情',
    basicInfo: '基本信息',
    readOnly: '数据来源于 OC，仅供查看',
    parties: '签约主体与相对方',
    ourParties: '我方签约主体',
    otherParties: '相对方',
    contractFiles: '合同文件',
    lastRefreshedAt: '本地最后刷新'
  },
  fields: {
    contractNumber: '合同编号',
    contractName: '合同名称',
    categoryCode: '合同分类编码',
    categoryName: '合同分类',
    ourPartyName: '我方签约主体名称',
    ourPartyNumber: '我方签约主体编码',
    tradingName: '相对方',
    otherPartyNumber: '相对方编码',
    supplierName: '关联供应商',
    statusCode: '合同状态',
    validityTag: '有效性',
    effectivePeriod: '有效期',
    effectiveStartDate: '有效日期从',
    effectiveEndDate: '有效日期至',
    amount: '合同金额',
    belongingDepartmentCode: '归属部门',
    principalNum: '负责人',
    ocLastUpdateDate: '最后更新',
    createdAt: '创建时间',
    creatorEmployeeNumber: '创建人工号',
    creatorName: '创建人',
    incomeExpenseType: '收支类型',
    currency: '币种',
    taxRate: '税率',
    sourceContractNumber: '来源合同编码',
    sourceTemplateNumber: '来源模板编码',
    operation: '操作'
  },
  placeholders: {
    keyword: '请输入关键词',
    select: '请选择',
    dateRange: ['开始日期', '结束日期'],
    amount: '请输入金额'
  },
  status: {
    s: '已签订',
    ar: '已归档'
  },
  validity: {
    valid: '有效',
    expiring: '即将到期',
    expired: '已过期'
  },
  incomeExpense: {
    i: '收入类',
    e: '支出类',
    a: '有收有支',
    n: '无收无支',
    separator: '、'
  },
  partySide: { our: '我方', other: '非我方' },
  party: {
    name: '名称',
    code: '编码',
    side: '我方/非我方',
    mainSigner: '是否主签',
    signatory: '是否签署方',
    roleOrder: '角色顺序'
  },
  files: {
    mainContract: '合同正文',
    attachments: '附件信息',
    archiveAttachments: '归档附件',
    archiveInfo: '归档信息',
    fileCount: '共 {count} 个文件',
    fileName: '文件名称',
    fileType: '文件类型',
    fileSize: '文件大小',
    ocFileId: 'OC 文件 ID',
    uploadedAt: '上传时间',
    status: '入库状态',
    archiveNumber: '归档编号',
    archiveSubmittedAt: '归档提交时间',
    archiveFileCount: '归档文件数',
    archivedBy: '归档提交人'
  },
  fileStatus: {
    stored: '已入库',
    not_downloaded: '未下载',
    downloading: '下载中',
    failed: '下载失败'
  },
  syncStatus: {
    pending: '待同步',
    syncing: '同步中',
    success: '成功',
    partial_failure: '部分失败',
    failed: '失败'
  },
  sync: {
    source: '数据来源',
    sourceName: '韶音一诺合同系统（OC）',
    status: '同步状态',
    lastSyncAt: '最后同步',
    total: '记录 {count}',
    success: '成功 {count}',
    failure: '失败 {count}'
  },
  actions: {
    detail: '详情',
    viewContract: '查阅合同',
    preview: '预览',
    download: '下载',
    refreshList: '刷新',
    syncSettings: '同步设置',
    syncNow: '手动触发同步',
    refreshContract: '刷新当前合同'
  },
  values: { unmatched: '未匹配' },
  messages: {
    loadListFailed: '供应商合同列表加载失败',
    loadDetailFailed: '供应商合同详情加载失败',
    connectionNotConfigured: 'OC 连接参数尚未在 Nacos 中配置完整',
    initialStartDateRequired: '请先在同步设置中选择首次同步日期',
    syncInProgress: '供应商合同正在同步，请稍候',
    syncSubmitted: '供应商合同同步任务已提交',
    syncFailed: '供应商合同同步失败',
    previewUnavailable: '该文件类型暂不支持在线预览，请下载后查看',
    previewBlocked: '浏览器阻止了预览窗口，请允许弹窗后重试',
    fileDownloadFailed: '合同文件下载失败',
    refreshSucceeded: '当前合同已刷新',
    refreshHidden: '合同已刷新，且已退出可见状态',
    refreshFailed: '当前合同刷新失败，请重试'
  }
}
